import { InjectionToken } from '@angular/core';
import * as Sentry from '@sentry/angular';

export type SentrySetUserFn = typeof Sentry.setUser;

export const SENTRY_SET_USER_TOKEN = new InjectionToken<SentrySetUserFn>('SentrySetUser');

export function provideSentrySetUser() {
  return {
    provide: SENTRY_SET_USER_TOKEN,
    useValue: Sentry.setUser,
  };
}
